module.exports = __webpack_public_path__ + "img/631.b4259924.jpg";